export const PLANNING_ENTITY_TYPES = {
  TRAINING: "entrenamiento",
  FRIENDLY_MATCH: "partidoAmistoso",
  WEEKLY_PLAN: "planSemanal",
};

export const PLANNING_ROLES = [
  "admin",
  "entrenador",
  "director_deportivo",
  "coach",
  "sporting_director",
];

export const normalizeRole = (role = "") =>
  String(role).trim().toLowerCase().replace(/\s+/g, "_");

export const findAuthorizedPlanningTeam = (
  teams = [],
  { externalTeamId, seasonId, federationId } = {}
) =>
  teams.find(
    (team) =>
      String(team?.external_team_id) === String(externalTeamId) &&
      String(team?.season_id) === String(seasonId) &&
      String(team?.federation_id) === String(federationId) &&
      team?.status === "active"
  ) ?? null;

export const canManagePlanning = (roleOrUser) => {
  const roles =
    roleOrUser && typeof roleOrUser === "object"
      ? [
          roleOrUser.rol,
          ...(roleOrUser.professionalRoles ?? []),
        ]
      : [roleOrUser];

  return roles.some((role) => PLANNING_ROLES.includes(normalizeRole(role)));
};

const getEntityId = (entity) =>
  entity?.id ?? entity?.idEquipo ?? entity?.idClub ?? null;

const getEntityName = (entity) =>
  entity?.nombre ?? entity?.name ?? entity?.equipoNombre ?? entity?.clubNombre ?? "";

export const resolvePlanningScope = (user = {}) => {
  const association = user.asociacion ?? user.association ?? {};
  const team = user.equipo ?? user.team ?? association.equipo ?? association.team;
  const club = user.club ?? association.club;

  const equipoId =
    user.equipoId ??
    user.idEquipo ??
    association.equipoId ??
    association.idEquipo ??
    getEntityId(team);
  const clubId =
    user.clubId ??
    user.idClub ??
    association.clubId ??
    association.idClub ??
    getEntityId(club);

  if (equipoId == null && clubId == null) return null;

  return {
    equipoId: equipoId ?? null,
    equipoNombre:
      user.equipoNombre ??
      association.equipoNombre ??
      getEntityName(team),
    clubId: clubId ?? null,
    clubNombre:
      user.clubNombre ??
      association.clubNombre ??
      getEntityName(club),
  };
};

export const startOfPlanningWeek = (value = new Date()) => {
  const date = new Date(value);
  date.setHours(0, 0, 0, 0);
  const day = date.getDay();
  date.setDate(date.getDate() - (day === 0 ? 6 : day - 1));
  return date;
};

export const addPlanningDays = (value, amount) => {
  const date = new Date(value);
  date.setDate(date.getDate() + amount);
  return date;
};

export const toLocalDateKey = (value) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("-");
};

export const getPlanningItemDate = (item = {}) =>
  item.fechaInicio ??
  item.startDate ??
  item.fechaISO ??
  item.fecha ??
  null;

export const groupPlanningItemsByDay = (items = []) =>
  items.reduce((groups, item) => {
    const dayKey = toLocalDateKey(getPlanningItemDate(item));
    if (!dayKey) return groups;
    if (!groups[dayKey]) groups[dayKey] = [];
    groups[dayKey].push(item);
    groups[dayKey].sort(
      (left, right) =>
        new Date(getPlanningItemDate(left)).getTime() -
        new Date(getPlanningItemDate(right)).getTime()
    );
    return groups;
  }, {});
